import React, { useState } from 'react'
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from '../Common/Component/HeaderCard'
import { createUser } from '../../lib/auth'
import { addData } from '../../lib/profiles'
import { useNavigate } from 'react-router-dom'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'
import { RoleSelectforNewRecord } from '../Common/FormSelects'

const AdminStudentCreate = () => {
	const [email, setEmail] = useState('')
	const [validationError, setValidationError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [role, setRole] = useState('')
	const [loading, setLoading] = useState(false)

	const navigate = useNavigate()
	const layout = useLayout()
	const roleFromUrl = useRoleBasedUrl()

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)
		setValidationError(false)
		setErrorMessage('')

		try {
			const { data, error } = await createUser(email, '12345', role)

			if (data?.user) {
				await addData({
					id: data.user.id,
					email: email,
					role: role
				})
				navigate(`${process.env.PUBLIC_URL}/${roleFromUrl}/students/edit/${data.user.id}/Add/${layout}`)
			} else if (error) {
				setValidationError(true)
				setErrorMessage('Error: ' + error.message)
			}
		} catch (error) {
			setValidationError(true)
			setErrorMessage('Error: ' + (error.message || 'Failed to create user'))
		} finally {
			setLoading(false)
		}
	}

	return (
		<>
			<Breadcrumbs parent="Student Management" title="Create Student" mainTitle="Create New Student" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<HeaderCard title="Create New Student" subTitle="Add a new student to the system" />
							<CardBody>
								<Form onSubmit={handleSubmit}>
									<Row>
										<Col md="6">
											<FormGroup>
												<Label for="email">Email Address</Label>
												<Input
													id="email"
													type="email"
													value={email}
													onChange={(e) => setEmail(e.target.value)}
													placeholder="Enter student's email address"
													required
													disabled={loading}
												/>
											</FormGroup>
										</Col>
										<Col md="6">
											<FormGroup>
												<RoleSelectforNewRecord value={role} setValue={setRole} />
											</FormGroup>
										</Col>
									</Row>

									{validationError && (
										<Alert color="danger" className="mt-3">
											{errorMessage}
										</Alert>
									)}

									<div className="d-flex justify-content-between mt-4">
										<Button type="submit" color="primary" disabled={loading || !email || !role}>
											{loading ? 'Creating...' : 'Next Step >>'}
										</Button>
										<Button type="button" color="secondary" onClick={() => navigate(-1)} disabled={loading}>
											Cancel
										</Button>
									</div>
								</Form>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { AdminStudentCreate }
